export default __webpack_public_path__ + "72edca03861e0d7ca161aac75e9f6b26.png";